<template>
  <v-page-content>
    <div v-if="isInitialized && !isSaving">
      <div class="d-flex justify-content-end mt-2 mb-2">
        <b-button-toolbar>
          <b-button-group>
            <b-button variant="primary" :pressed="true" class="mr-2">
              <em class="fas fa-info" /> Статус:
                {{ content.contentObject.status }}
            </b-button>
            <b-button
              variant="outline-primary"
              @click="onSaveClick()"
              :disabled="isContentSaved"
              class="mr-2"
              >
              <em class="far fa-1x fa-save"></em> Сохранить
            </b-button>
            <b-button
              variant="outline-primary"
              @click="onEditMode()"
              class="mr-2"
              >
              <em :class="isEditMode ? 'far fa-edit' : 'fas fa-pen'" />
                {{ isEditMode ? ' Режим просмотра' : ' Редактировать' }}
            </b-button>
              <b-button variant="outline-primary" @click="onClose">
                <em class="fas fa1-x fa-times-circle" /> Назад
              </b-button>
          </b-button-group>
        </b-button-toolbar>
      </div>
      <b-row align-v="end">
        <b-col>
          <ToolsSelector :panel="panel" v-model="selectedTool" />
        </b-col>
        <b-col sm="auto">
          <b-button-group class="mb-1">
            <b-button variant="outline-primary" size="lg" @click="goPrev">
              <em class="fas fa-caret-left"></em>
            </b-button>
            <b-button variant="outline-primary" size="lg" @click="goNext">
              <em class="fas fa-caret-right"></em>
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <b-row class="pt-2">
        <b-col sm="3" v-if="isEditMode">
          <b-card
            border-variant="primary"
            class="mb-2"
            no-body>
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.collapse-panel variant="primary">
                Пульт
              </b-button>
            </b-card-header>
            <b-collapse id="collapse-panel" accordion="panel-accordion">
              <b-card-body>
                <b-form-group label="id" class="mb-2">
                  <b-form-input type="number" v-model="panel.id" readonly />
                </b-form-group>
                <b-form-group label="Имя" class="mb-2">
                  <b-form-input type="text" v-model="panel.name" @change="onChange" />
                </b-form-group>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card
            v-if="$refs.panel && itemToDelete"
            border-variant="primary"
            class="mb-2"
            no-body
            >
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.collapse-elem variant="primary">
                Элемент
              </b-button>
            </b-card-header>
            <b-collapse id="collapse-elem" visibile accordion="panel-accordion">
              <b-card-body>
                <b-form-group label="id" class="mb-1">
                  <b-form-input
                    type="number"
                    v-model="itemToDelete.id"
                    readonly number
                    />
                </b-form-group>
                <b-form-group label="Элемент" class="mb-1">
                  <b-form-select
                    v-model="itemToDelete.itemId"
                    :options="elementOptions"
                    @change="onItemEdited"
                    />
                </b-form-group>
                <b-form-group label="zIndex" class="mb-1">
                  <b-form-input
                    type="number"
                    v-model="itemToDelete.zIndex"
                    number
                    @change="onZIndexChange"
                    />
                </b-form-group>
                <b-button
                  block
                  variant="outline-primary"
                  @click="onDelete"
                  :disabled="!itemToDelete"
                  >
                  <em class="fas fa-times"></em> Удалить
                </b-button>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card
            v-if="$refs.panel && itemToDelete"
            border-variant="primary"
            no-body
            >
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.collapse-coords variant="primary">
                Геометрия
              </b-button>
            </b-card-header>
            <b-collapse id="collapse-coords" accordion="panel-accordion">
              <b-card-body>
                <CoordsEditor
                  v-model="itemToDelete.coords"
                  :key="editKey"
                  @change="onItemEdited"
                  stacked
                  />
                <b-form-group label="r" label-cols-sm="1" class="mb-1">
                  <b-form-input
                    type="number"
                    v-model="itemToDelete.rotation.angle"
                    @change="onItemEdited"
                    step="10"
                    number
                    />
                </b-form-group>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-col>
        <b-col :sm="isEditMode ? '9' : '12'" class="text-center">
          <div class="mt-2 mx-auto">
            <div class="changingPanelDiv__panel">
              <training-panel
                ref="panel"
                :panelId="panelId"
                :editMode="isEditMode"
                @change="onChange"
                />
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <div v-else class="d-flex justify-content-center mt-5">
      <b-spinner
        variant="primary"
        style="width: 5cm; height: 5cm;"
        label="Загрузка..."
        ></b-spinner>
    </div>
  </v-page-content>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import _ from 'lodash'
import CoordsEditor from '@/components/content/education/training/tools/CoordsEditor.vue'
import RouteMixin from '@/components/helpers/mixins/route-mixin'
import ToolsSelector from '@/components/content/education/training/tools/ToolsSelector.vue'
import TrainingPanel from '@/components/content/education/training/TrainingPanel.vue'

export default {
  name: 'TrainingPanelChanging',
  components: {
    CoordsEditor,
    ToolsSelector,
    TrainingPanel
  },
  mixins: [RouteMixin],
  created() {
    if (!this.isInitialized) {
      this.onClose()
    } else {
      [this.selectedTool] = this.panel.tools
      this.panelIds = this.panels.map((panel) => panel.id)
    }
    this.debouncedSortPanel = _.debounce(() => {
      this.panel.sortItems()
      this.debouncedUpdatePanel()
    }, 200)
    this.debouncedUpdateEdtior = _.debounce(() => {
      this.editKey += 1
    }, 250)
    this.debouncedUpdatePanel = _.debounce(() => {
      this.$refs.panel.setOverlap()
      this.$refs.panel.drawAll()
      this.$refs.panel.drawGuides()
    }, 250)
  },
  beforeRouteLeave(to, from, next) {
    this.$_handleRoute(next, this.isContentSaved, this.updater)
  },
  beforeRouteUpdate(to, from, next) {
    this.$_handleRoute(next, this.isContentSaved, this.updater)
  },
  data() {
    return {
      selectedTool: null,
      isEditMode: false,
      isSaving: false,
      editKey: 0
    }
  },
  watch: {
    selectedTool(tool) {
      this.$refs.panel.setTool(tool)
    },
    updater(newUpdater) {
      if (newUpdater > 0) {
        this.updateContentSavedStatus(false)
        window.onbeforeunload = () => 'Имеются несохранённые изменения. Вы точно хотите закрыть страницу?'
      } else {
        this.updateContentSavedStatus(true)
        window.onbeforeunload = undefined
      }
    },
    panelId() {
      [this.selectedTool] = this.panel.tools
    }
  },
  computed: {
    ...mapGetters({
      content: 'training/getTrainingContent',
      elements: 'training/getElements',
      isContentSaved: 'contentManager/isContentSaved',
      isInitialized: 'training/getIsTrainingInitialized',
      panels: 'training/getPanels',
      updater: 'contentManager/getUpdater'
    }),
    canSave() {
      return true // TODO
    },
    itemToDelete() {
      return this.$refs.panel.editItem
    },
    panel() {
      return this.panels.find((p) => p.id === this.panelId)
    },
    panelId() {
      return Number(this.$route.params.panelId)
    },
    elementOptions() {
      return this.elements.items.map((item) => {
        const isActive = item.activeZones ? '[ACTIVE] ' : ' '
        return {
          value: item.id,
          text: `${item.id} ${isActive}(${item.displayFunction})`
        }
      })
    }
  },
  methods: {
    ...mapMutations({
      updateContentSavedStatus: 'contentManager/updateContentSavedStatus',
      freezeUpdater: 'contentManager/freezeUpdater'
    }),
    ...mapActions({
      objectsToFiles: 'training/objectsToFiles',
      updateTrainingContent: 'training/updateTrainingContent',
      updateUpdater: 'contentManager/updateUpdater'
    }),
    async onSaveClick() {
      this.isSaving = true
      await this.updateTrainingContent()
      this.updateUpdater(0)
      this.isSaving = false
      this.$nextTick(() => {
        this.$refs.panel.setTool(this.selectedTool)
      })
    },
    onDelete() {
      this.panel.deleteItem(this.itemToDelete.id)
      this.updateUpdater()
      this.$refs.panel.initPanel()
    },
    onChange() {
      this.updateUpdater()
      this.debouncedUpdateEdtior()
    },
    onZIndexChange() {
      this.updateUpdater()
      this.debouncedSortPanel()
    },
    onItemEdited() {
      this.updateUpdater()
      this.debouncedUpdatePanel()
    },
    onEditMode() {
      this.isEditMode = !this.isEditMode
    },
    goNext() {
      const index = this.panelIds.indexOf(this.panelId)
      const newIndex = (index + 1) % this.panelIds.length
      const newId = this.panelIds[newIndex]
      this.$router.push(
        `/content/training/${this.$route.params.trainingId}/panels/${newId}`,
      )
    },
    goPrev() {
      const index = this.panelIds.indexOf(this.panelId)
      let newIndex = index - 1
      newIndex = newIndex < 0 ? newIndex + this.panelIds.length : newIndex
      const newId = this.panelIds[newIndex]
      this.$router.push(
        `/content/training/${this.$route.params.trainingId}/panels/${newId}`,
      )
    },
    onClose() {
      this.$router.push(`/content/training/${this.$route.params.trainingId}`)
    }
  }
}
</script>

<style scoped>
.changingPanelDiv__panel {
  clear: both;
}
</style>
